<script type="text/javascript">
    
    import moment from "moment";
    import Chart from "chart.js";
    import { onDestroy, onMount } from "svelte";

    export let title = "Chart";
    export let data = null; // {key: value, key2: value}

    let chart = null;
    let canvas = null;

    onMount(() => {
       updateChart();
    })
    onDestroy(()=>{
		if (chart !== null) {
			chart.destroy();
			chart = null;
		}
    });
    $: {
        updateChart();
    }

    export const updateData = () => {
        if (chart !== null) {
			chart.data.datasets[0].data = Object.values(data);
            chart.update();
        }
    };

    export const updateChart = () => {
        // console.log("update chart", chart, canvas, data);
        if (chart === null && canvas !== null && data !== null) {
            
            const CHART_COLORS = {
                red: 'rgb(255, 99, 132)',
                orange: 'rgb(255, 159, 64)',
                yellow: 'rgb(255, 205, 86)',
                green: 'rgb(75, 192, 192)',
                blue: 'rgb(54, 162, 235)',
                purple: 'rgb(153, 102, 255)'
            };
            const chartData = {
                labels: Object.keys(data), 
                datasets: [
                    {
                        label: title, //'Flag',
                        data: Object.values(data), 
                        backgroundColor: Object.values(CHART_COLORS),
                    }
                ]
            };

            const config = {
                type: 'pie',
                data: chartData,
                options: {
                    responsive: true,
                    plugins: {
                        legend: {
                            position: 'top',
                        },
                        title: {
                            display: true,
                            text: title //'Pie Chart'
                        }
                    }
                },
            };
            chart = new Chart(canvas.getContext("2d"), config);
        }
        if (chart !== null && canvas !== null) {
            chart.update();
        }
    };
    
</script>

<p><b>{title}</b></p>
<canvas bind:this={canvas}></canvas>    